module.exports = __webpack_public_path__ + "img/Bleaching_1200x800.be0e858b.svg";